import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useQuery } from '@apollo/client';
import PropTypes from 'prop-types';

import { getPrefectureName } from '../../utils';
import { getNameFromOptions, convertEnumValuesToOptions, addUnselectedOption } from '../../utils/search';
import { setTagId, setKeyword, setSearchCondition } from '../../modules/hotel';
import { UNSELECTED_LABEL } from '../../constants';
import { FetchRoomTypes, FetchMealConditions, FetchTaggroups, FetchDirections, FetchSearchConditions } from '../../queries/index.graphql';

const hotelSelector = (state) => state.hotel;

const SearchConditionSPHotel = ({ handleSearch }) => {
  const dispatch = useDispatch();
  const [searchCount, setSearchCount] = useState(0);
  const {
    hotelsInput,
  } = useSelector(hotelSelector);
  const {
    stayNights,
    numberOfRooms,
    peoplePerRoom,
    directionId,
    prefectureId,
    areaId,
    districtId,
    roomType,
    mealCondition,
    tagIds,
    keyword,
    // sortOrder,
    searchCondition,
  } = hotelsInput;

  useEffect(() => {
    if (searchCount) {
      handleSearch();
    }
  }, [searchCount]);

  const { data } = useQuery(FetchDirections);
  const directions = data ? data.directions : [];
  const direction = directions.find((d) => d.id === directionId);
  const prefectures = direction ? direction.prefectures : [];
  const prefecture = prefectures.find((p) => p.id && p.id === prefectureId);
  const areas = prefecture ? addUnselectedOption(prefecture.areas, UNSELECTED_LABEL) : addUnselectedOption([]);
  const area = areas.find((a) => a.id && a.id === areaId);
  const districts = area ? addUnselectedOption(area.districts, UNSELECTED_LABEL) : addUnselectedOption([]);

  const stayNightsDisplay = `泊数：${stayNights}泊`;
  const peopleDisplay = `部屋数・人数：${peoplePerRoom}名${numberOfRooms}室`;

  const directionName = getNameFromOptions(directionId, directions);
  const prefectureName = getPrefectureName(prefectureId, prefectures);
  const areaName = getNameFromOptions(areaId, areas) || UNSELECTED_LABEL;
  const districtName = getNameFromOptions(districtId, districts) || UNSELECTED_LABEL;
  const placeDisplay = `${directionName}/${prefectureName}/${areaName}/${districtName}`;

  const { data: roomTypesData } = useQuery(FetchRoomTypes);
  const roomTypes = roomTypesData ? convertEnumValuesToOptions(roomTypesData.__type.enumValues) : [];
  const roomTypeName = getNameFromOptions(roomType, roomTypes);
  const roomTypeDisplay = roomTypeName && `部屋タイプ：${roomTypeName}`;
  const { data: mealConditionsData } = useQuery(FetchMealConditions);
  const mealConditions = mealConditionsData ? convertEnumValuesToOptions(mealConditionsData.__type.enumValues) : [];
  const mealConditionName = getNameFromOptions(mealCondition, mealConditions);
  const mealConditionDisplay = mealConditionName && `食事条件：${mealConditionName}`;
  const { data: taggroupsData } = useQuery(FetchTaggroups);
  const { data: searchConditionsData } = useQuery(FetchSearchConditions);
  const taggroups =  taggroupsData && taggroupsData.taggroups;
  const searchConditions = searchConditionsData ? searchConditionsData.searchConditions : [];

  const filterSelectedTag = (tags) => tags.filter(({ id }) => tagIds.includes(id));
  const currentSearchConditions = searchCondition || [];
  const filterSelectedSearchCondition = (conditions) =>
    (conditions || []).filter(({ param }) => currentSearchConditions.includes(param));

  return (
    <div className="searchCondition">
      <div className="searchConditionTitle">選択中の宿泊条件</div>
      <div className="searchConditionTitleItem">
        <img className="searchConditionTitleItemIcon" src="/dp-air/img/icons/icon_stay.svg" />
        <div>
          <div className="searchConditionTitleItemLine">
            {stayNightsDisplay}<span style={{ marginRight: 20 }} />{peopleDisplay}
          </div>
          <div className="searchConditionTitleItemLine">{roomTypeDisplay}</div>
          {mealConditionDisplay}
        </div>
      </div>
      {!!(directionName && prefectureName) && (
        <div className="searchConditionTitleItem">
          <img className="searchConditionTitleItemIcon" src="/dp-air/img/icons/icon_place.svg" />
          {placeDisplay}
        </div>
      )}
      <div className="searchConditionTagContainer">
        {taggroups && taggroups.map(({ tags }) => (
          filterSelectedTag(tags).map(({ id: tagId, name }) => (
            <div className="searchConditionTagItem" key={tagId}>
              {name}
              <a
                onClick={() => {
                  dispatch(setTagId(tagId));
                  setSearchCount(searchCount + 1);
                }}
              >
                <img className="searchConditionDeleteIcon" src="/dp-air/img/icons/icon_delete.svg" />
              </a>
            </div>
          ))
        ))}

        {filterSelectedSearchCondition(searchConditions).map(({ name, param }) => (
          <div className="searchConditionTagItem" key={param}>
            {name}
            <a
              onClick={() => {
                dispatch(setSearchCondition(param));
                setSearchCount(searchCount + 1);
              }}
            >
              <img className="searchConditionDeleteIcon" src="/dp-air/img/icons/icon_delete.svg" />
            </a>
          </div>
        ))}

        {keyword && (
          <div className="searchConditionTagItem">
            {keyword}
            <a
              onClick={() => {
                dispatch(setKeyword(undefined));
                setSearchCount(searchCount + 1);
              }}
            >
              <img className="searchConditionDeleteIcon" src="/dp-air/img/icons/icon_delete.svg" />
            </a>
          </div>
        )}

      </div>
    </div>
  );
};

SearchConditionSPHotel.propTypes = {
  handleSearch: PropTypes.func.isRequired,
};

export default SearchConditionSPHotel;